console.log('✅ home-page-responsive-sidebar.js loaded!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import { buildComponentShipToCountrySidebar, initbuildComponentShipToCountrySidebar } from '../header/ship-to-country-sidebar.js';
import { buildComponentSelectCurrencySidebar, initbuildComponentSelectCurrencySidebar } from '../header/select-currency-sidebar.js';
import { buildComponentSelectLanguageSidebar, initbuildComponentSelectLanguageSidebar } from '../header/select-language-sidebar.js';
import { buildComponentLoginUserOptionsSidebar, initbuildComponentLoginUserOptionsSidebar } from '../header/login-user-options-sidebar.js';
import { buildComponentCatalogBlogCategoriesForMainSidebar, initbuildComponentCatalogBlogCategoriesForMainSidebar } from '../header/catalog-blog-categories-sidebar.js';
import { fetchAllCategories } from '../../services/data-services/catalog-data-service.js';

export async function buildComponentHomePageResponsiveSidebar() {
  console.log(
    `🔄 Building Component: buildComponentHomePageResponsiveSidebar - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    let htmlToRender = '';

    if (isNodeEnvironment()) {
      htmlToRender = await buildActualContent();
    } else {
      htmlToRender = await buildPageSkeleton();
    }

    const html = `
      


    ${htmlToRender}

      


        `;

    console.log('✅ buildComponentHomePageResponsiveSidebar built successfully.');

    // // Register event listeners
    // // registerEventListenerToAttach(attachEventListenersCatalogProducts);
    registerEventListenerToAttach(async () => initComponentHomePageResponsiveSidebar());

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentHomePageResponsiveSidebar:', err);
    return '<div>Error loading buildComponentHomePageResponsiveSidebar </div>';
  }
}

export async function buildPageSkeleton() {
  //  // Top two “featured” cards
  //  const topCardsSkeletonHtml = `
  //    <br />
  //  <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
  //      <div class="my-site-lazy-loading-card">
  //          <div class="my-site-lazy-loading-card-movement"></div>
  //      </div>
  //  </div>
  //`;

  //  const topCardsSkeletonHtml2 = `
  //  <div class="grid-blog-category-home-featured-top-card my-fake-image-height-400">
  //      <div class="my-site-lazy-loading-card">
  //          <div class="my-site-lazy-loading-card-movement"></div>
  //      </div>
  //  </div>
  //  `;

  //  let middleCardsSkeleton = '';
  //  for (let i = 0; i < 4; i++) {
  //      middleCardsSkeleton += `
  //    <div class="grid-blog-home-featured-middle-section-card my-fake-image-height-400">
  //                                  <div class="my-site-lazy-loading-card">
  //                                      <div class="my-site-lazy-loading-card-movement"></div>
  //                                  </div>
  //                              </div>

  //  `;
  //  }

  //  // Sidebar section: repeat 5 times
  //  let sideBarCardsSkeleton = '  <br>  <br>';
  //  for (let i = 0; i < 5; i++) {
  //      sideBarCardsSkeleton += `
  //              <div class="grid-blog-home-bottom-section-card my-fake-image-height-125">
  //                          <div class="my-site-lazy-loading-card">
  //                              <div class="my-site-lazy-loading-card-movement"></div>
  //                          </div>
  //                      </div>

  //                      <br />

  //  `;
  //  }

  //  // Middle section: repeat 6 times
  //  let bottomCardsSkeleton = '';
  //  for (let i = 0; i < 6; i++) {
  //      bottomCardsSkeleton += `
  //   <div class="grid-blog-home-bottom-section-card my-fake-image-height-400">
  //                      <div class="my-site-lazy-loading-card">
  //                      <div class="my-site-lazy-loading-card-movement"></div>
  //                  </div>
  //              </div>
  //  `;
  //  }

  const html = `
       <div id="placeholder-buildComponentHomePageResponsiveSidebar">
 

    </div>
    
   
  `;

  return html;
}

export async function buildActualContent() {
  // alert("2 attaching event listeners to omePageResponsiveSidebar");

  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  //// ❶ Load translations & routes
  //await initTempTextTranslator(lang);
  //await initTempLinksTranslator(lang);

  const {
    keyAllCategories: lblAllCategories,
    keyArticlesAndBlog: lblArticlesAndBlog,
    keyBlog: lblBlog,
    keyContactUs: lblContactUs,
    keyAboutUs: lblAboutUs,
    keyBecomeASeller: lblBecomeASeller,
    keyTrackYourOrder: lblTrackYourOrder,
    keyRefundsAndReplacements: lblRefundsAndReplacements,
    keyFAQ: lblFAQ,
    keySelectShipTo: lblSelectShipTo,
    keySelectCurrency: lblSelectCurrency,
    keySelectLanguage: lblSelectLanguage,
  } = _tempTextTranslator;

  const {
    keyCategory: linkCategory,
    keyCategories: linkCategories,
    keyBlog: linkBlog,
    keyContactUs: linkContactUs,
    keyAboutUs: linkAboutUs,
    keySell: linkSell,
    keyMyOrders: linkMyOrders,
    keyMyReturns: linkMyReturns,
    keyFAQs: linkFAQ,
    keySelectShipTo: linkSelectShipTo,
    keySelectCurrency: linkSelectCurrency,
    keySelectLanguage: linkSelectLanguage,
  } = _tempLinksTranslator;

  const departments = await fetchAllCategories(); // aka departments

  const selectBlogCategoriesSidebarHtml = await buildComponentCatalogBlogCategoriesForMainSidebar();
  const selectShipToCountrySidebarHtml = await buildComponentShipToCountrySidebar();
  const selectCurrencySidebarHtml = await buildComponentSelectCurrencySidebar();
  const selectLanguageSidebarHtml = await buildComponentSelectLanguageSidebar();
  const selectUserLoginSidebarHtml = await buildComponentLoginUserOptionsSidebar();

  const deptLinksHtml = departments
    // only the ones marked for the home‐page sidebar
    .filter(d => d.isOnHomePageSideNav === true)
    // then map to your <a> tags
    .map(d => {
      const link = `/${appState.SiteLanguageCookie}/${d.departmentID}/${d.seoPageName}`;
      return `
      <a href="${link}" class="sidebar-link" data-close-on-click>     ${d.name}  </a>`;
    })
    .join('');

  // ➌ Return the full markup
  const html = `

     <div class="NavListToggleFaBarcontainer" id="btnNavListToggleFaBarcontainer">
        <div class="NavListTogglebar1"></div>
        <div class="NavListTogglebar2"></div>
        <div class="NavListTogglebar3"></div>
    </div>


<div id="NavigationSidePanel" class="NewNavSidePanelStyle">

    <div id="NavigationSidePanel-OverLay" class="NewNavSidePanelStyle-backlay">
    </div>
    <div id="my-main-side-bar-content-holder" class="NewNavSidePanelStyle-main-content-holder">


        <div class="SideNavHeaderWrapper">
            <table style="width:100%;border:none;">
                <tr>
                    <td style="width:80%;border:none;text-align:center;">
                        <div class="SideNavCenterLogo">

                            <a href="/" data-close-on-click>  <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/logo/logo.jpg" width="159" height="44" alt="Towobo" class="logo-Image" />
                                </a>


                        </div>
                    </td>
                    <td style="width:20%;border:none;text-align:right;">     <div id="SideNavHeader-mini-Closebtn" class="SideNavHeaderClosebtn"> &times; </div> </td>
                </tr>
            </table>





            <!--  -->

        </div>

          <div class="SideNavLinksWrapper">                    

            <a href="${linkCategories}" class="sidebar-link" data-close-on-click>     ${lblAllCategories}  </a>

           ${deptLinksHtml}
              
          

            ${selectBlogCategoriesSidebarHtml}

              <a href="${linkContactUs}" class="sidebar-link" data-close-on-click>     ${lblContactUs}  </a>
                <a href="${linkAboutUs}" class="sidebar-link" data-close-on-click>     ${lblAboutUs}  </a>
                <a href="${linkSell}" class="sidebar-link" data-close-on-click>     ${lblBecomeASeller}  </a>
                <a href="${linkMyOrders}" class="sidebar-link" data-close-on-click>     ${lblTrackYourOrder}  </a>
                <a href="${linkMyReturns}" class="sidebar-link" data-close-on-click>     ${lblRefundsAndReplacements}  </a>

               
                 
                ${selectShipToCountrySidebarHtml}
                ${selectCurrencySidebarHtml}
                ${selectLanguageSidebarHtml}
              
                        



                <a href="${linkFAQ}" class="sidebar-link" data-close-on-click>     ${lblFAQ}  </a>

 </div>

              <div class="SideNavFooterWrapper">
            ${selectUserLoginSidebarHtml}

        </div>

           

            
        <div class="SideNavLastFooterWrapper"></div>

        
    </div>
    </div>
   
  `;

  return html;
}

export async function initComponentHomePageResponsiveSidebar() {
  try {
    console.log('✅ buildComponentHomePageResponsiveSidebar event listeners attached.');

    let htmlToRender = await buildActualContent();

    const currentPlacholder = document.querySelector(
      '#placeholder-buildComponentHomePageResponsiveSidebar'
    );
    if (currentPlacholder) {
      currentPlacholder.innerHTML = htmlToRender;
    }


     await initbuildComponentCatalogBlogCategoriesForMainSidebar();
     await initbuildComponentShipToCountrySidebar();
     await initbuildComponentSelectCurrencySidebar();
     await initbuildComponentSelectLanguageSidebar();
     await initbuildComponentLoginUserOptionsSidebar();

     await initbuildComponentLoginUserOptionsSidebar();


    //    alert("attaching event listeners to homePageResponsiveSidebar");

    await setupSidePanelEventListeners();
  } catch (error) {
    console.error('❌ Error attaching event listeners to homePageResponsiveSidebar:', error);
  }
}

export async function setupSidePanelEventListeners() {
  // Open side panel button
  const btn = document.getElementById('btnNavListToggleFaBarcontainer');
  if (btn) {
    const onOpenClick = async () => await handleSidePanelOpen();
    btn.removeEventListener('click', onOpenClick);
    btn.addEventListener('click', onOpenClick);
  }

  // Close button inside panel
  const closeBtn = document.getElementById('SideNavHeader-mini-Closebtn');
  if (closeBtn) {
    const onCloseClick = async () => await handleSidePanelClose();
    closeBtn.removeEventListener('click', onCloseClick);
    closeBtn.addEventListener('click', onCloseClick);
  }

  // Overlay click to close
  const overlay = document.getElementById('NavigationSidePanel-OverLay');
  if (overlay) {
    const onOverlayClick = async () => await handleSidePanelClose();
    overlay.removeEventListener('click', onOverlayClick);
    overlay.addEventListener('click', onOverlayClick);
  }

  // Links inside side panel that should close the panel when clicked
  const closeOnClickLinks =
    document
      .getElementById('my-main-side-bar-content-holder')
      ?.querySelectorAll('[data-close-on-click]') || [];

  closeOnClickLinks.forEach(link => {
    const onLinkClick = () => handleSidePanelClose();
    link.removeEventListener('click', onLinkClick);
    link.addEventListener('click', onLinkClick);
  });
}

async function handleSidePanelOpen() {
  // alert("panel opened");

  //prevents scroll
  const docBodyElement = document.getElementsByTagName('body')[0];
  if (docBodyElement) {
    docBodyElement.style.overflow = 'hidden';
  }

  const elementMainSideBarHolder = document.getElementById('my-main-side-bar-content-holder');

  if (elementMainSideBarHolder) {
    elementMainSideBarHolder.style.transition = '0.2s ease-in';
  }

  const elementSidePanel = document.getElementById('NavigationSidePanel');

  if (elementSidePanel) {
    elementSidePanel.style.width = '90%';
  }

  const elementSidePanelOverLay = document.getElementById('NavigationSidePanel-OverLay');

  if (elementSidePanelOverLay) {
    elementSidePanelOverLay.style.width = '100%';
  }

  if (elementMainSideBarHolder) {
    elementMainSideBarHolder.style.left = '0';
  }
}

async function handleSidePanelClose() {
  const docBodyElement = document.getElementsByTagName('body')[0];
  if (docBodyElement) {
    docBodyElement.style.overflow = 'visible';
  }

  const elementMainSideBarHolder = document.getElementById('my-main-side-bar-content-holder');
  if (elementMainSideBarHolder) {
    elementMainSideBarHolder.style.transition = 'none';
  }

  const elementSidePanel = document.getElementById('NavigationSidePanel');
  if (elementSidePanel) {
    elementSidePanel.style.width = '0';
  }

  const elementSidePanelOverLay = document.getElementById('NavigationSidePanel-OverLay');
  if (elementSidePanelOverLay) {
    elementSidePanelOverLay.style.width = '0';
  }

  if (elementMainSideBarHolder) {
    elementMainSideBarHolder.style.left = '-100%';
  }
}
